import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'

import config from '../../config'
import Pagination from '../pagination'

class ConsentsListComponent extends Component {
  constructor(props){
    super(props)
    this.state = {
      users: [],
      count: 0,
      loaded: false,
      searchString: '',
      perPage: 50,
      page: 1,
      role: null,
    }
  }

  componentDidMount() {
    this.getUsers()
  }

  getUsers = () => {
    let queryString = '?';
    this.state.page ? queryString += `&page=${this.state.page}` : null
    this.state.perPage ? queryString += `&perPage=${this.state.perPage}` : null
    this.state.role ? queryString += `&role=${this.state.role}` : null

    axios.get(`${config.apiUrl}/users${queryString}`)
      .then(response => {
        if (response.data.data && response.data.data.rows && response.data.data.count) {
          this.setState({users: response.data.data.rows, count: response.data.data.count}, () => {
            this.setState({loaded: true})
          })
        }
      })
      .catch(error => {
        console.error(error)
      })
  };

  paginate = (e, key) => {
    e.preventDefault()
    let page = this.state.page
    if (typeof key === 'number') {
      page = key
    } else if (key === 'next') {
      page = page + 1
    } else if (key === 'previous') {
      page = page - 1
    }
    this.setState({page: page}, () => this.getUsers())
  };

  render () {
    let users = this.state.users;

    return (
       <div className="container-fluid">
          <div className="row">
            <div className="col">
              <h1>Users</h1>
            </div>
            <div className="col col-sm-auto">
              <form className="form-inline mb-4">
                <div className="form-check form-check-inline ml-3">
                  <input className="form-check-input" type="checkbox" id={`admin`} value="admin" checked={this.state.role === 'admin' ? 'checked' : ''} onChange={e => {
                    if (this.state.role !== 'admin' && e.target.checked) {
                      this.setState({role: 'admin', page: 1}, () => {this.getUsers()})
                    } else {
                      this.setState({role: null, page: 1}, () => {this.getUsers()})
                    }
                  }} />
                  <label className="form-check-label" htmlFor={`admin`}>Only admins</label>
                </div>
              </form>
            </div>
          </div>

          <Pagination paginate={this.paginate.bind(this)} page={this.state.page} perPage={this.state.perPage} count={this.state.count} rows={this.state.users} />

          <table className="table table-striped table-bordered table-hover">
            <thead className="thead-dark">
              <tr>
                <th>Email</th>
                <th>First name</th>
                <th>Last name</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Preferred language</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => {
                return (
                  <tr className="th-hover" key={user.id}>
                    <td>{user.email || 'Unknown'}</td>
                    <td>{user.firstName || 'Unknown'}</td>
                    <td>{user.lastName || 'Unknown'}</td>
                    <td>{user.phone || 'Unknown'}</td>
                    <td>{user.role || 'Unknown'}</td>
                    <td>{user.preferredLanguage === 'nb' && 'Norwegian' || user.preferredLanguage === 'en' && 'English' || 'Unknown'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {users.length === 0 && <div>Ingen treff</div>}

          <Pagination paginate={this.paginate.bind(this)} page={this.state.page} perPage={this.state.perPage} count={this.state.count} rows={this.state.users} />
        </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    layout: state.layout
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
  }
}

const UsersList = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsentsListComponent);

export default UsersList



// WEBPACK FOOTER //
// ./src/components/users-list/index.js